var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.platform === null)?_c('div',[_c('SelectPlatform',{on:{"platform:selected":_vm.setPlatform}})],1):_c('div',[_c(_vm.platform.component,{tag:"component",attrs:{"platform":_vm.platform},on:{"canceled":function($event){_vm.platform = null},"account:saved":_vm.refreshAccounts}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }